import { useQuery, UseQueryOptions } from 'react-query';

import { ActiveDataRoom, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useOtherActiveDealsQuery(
	guid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<ActiveDataRoom[], unknown, ActiveDataRoom[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.OtherActiveDeals(guid),
		() =>
			AxiosUtils.getResponseData<ActiveDataRoom[]>(api.get(CerebroApiEndpoints.DataRooms.OtherActiveDeals(guid))),
		options
	);
}
